module.exports = __webpack_public_path__ + "img/business-chart-strategy-analysis-concept-removebg-preview 1.c5662d9a.png";